import React, { useEffect, useState, useRef } from 'react';
import { HOUSING_TYPES_ONBOARDING, CONSTRUCTION_PERIOD_OPTIONS, HOUSE_FLOORS } from '../../../lib/constants';
import { OnboardingDraft } from './types';
import { Input } from '../../ui/Input';
import { CaretDown } from '@phosphor-icons/react';
import { cn } from '../../../lib/utils';
interface StepListingTypeProps {
  data: Partial<OnboardingDraft>;
  updateData: (data: Partial<OnboardingDraft>) => void;
}
const APARTMENT_FIXED_PILLS = [{
  value: 'demisol',
  label: 'Demisol'
}, {
  value: 'parter',
  label: 'Parter'
}, {
  value: 'mansarda',
  label: 'Mansardă'
}];
export function StepListingType({
  data,
  updateData
}: StepListingTypeProps) {
  const toggleFloor = (val: string) => {
    const current = data.floorPreferences || [];
    if (current.includes(val as any)) {
      updateData({
        floorPreferences: current.filter(f => f !== val) as any
      });
    } else {
      updateData({
        floorPreferences: [...current, val] as any
      });
    }
  };
  const isHouse = data.housingType === 'house';
  return <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1570">
      <div data-id="element-1571">
        <h2 className="text-2xl font-bold text-light-1" data-id="element-1572">Ce cauți?</h2>
      </div>

      <div className="space-y-3" data-id="element-1573">
        {HOUSING_TYPES_ONBOARDING.map(type => {
        const isSelected = data.housingType === type.value;
        return <div key={type.value} className="space-y-3" data-id="element-1574">
              <button onClick={() => updateData({
            housingType: type.value as any
          })} className={`w-full flex items-center p-4 rounded-xl border-2 transition-all ${isSelected ? 'border-lime-1 bg-lime-5 text-light-1' : 'border-dark-3 bg-dark-2 text-light-2 hover:border-dark-4 hover:bg-dark-3'}`} data-id="element-1575">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center mr-4 ${isSelected ? 'border-lime-1' : 'border-dark-4'}`} data-id="element-1576">
                  {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-lime-1" data-id="element-1577" />}
                </div>
                <span className="font-medium" data-id="element-1578">{type.label}</span>
              </button>

              {/* Conditional sub-selectors */}
              {isSelected && type.value === 'apartment' && <div className="pl-10 pr-4 py-2 animate-in slide-in-from-top-2 fade-in duration-300 space-y-4" data-id="element-1579">
                  <div className="flex flex-wrap gap-2" data-id="element-1580">
                    {[2, 3, 4].map(num => <button key={num} onClick={() => updateData({
                rooms: num as any
              })} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${data.rooms === num ? 'bg-lime-1 text-dark-1' : 'bg-dark-3 text-light-2 hover:bg-dark-4'}`} data-id="element-1581">
                        {num === 4 ? '4+ camere' : `${num} camere`}
                      </button>)}
                  </div>
                  <label className="flex items-center gap-3 cursor-pointer" data-id="element-1582">
                    <input type="checkbox" checked={data.duplexPreference || false} onChange={e => updateData({
                duplexPreference: e.target.checked
              })} className="w-4 h-4 rounded border-dark-4 text-lime-1 focus:ring-lime-1 bg-dark-2" data-id="element-1583" />
                    <span className="text-sm text-light-2" data-id="element-1584">
                      Preferință pentru Duplex / Penthouse
                    </span>
                  </label>
                </div>}

              {isSelected && type.value === 'room' && <div className="pl-10 pr-4 py-2 animate-in slide-in-from-top-2 fade-in duration-300 space-y-2" data-id="element-1585">
                  {(['apartment', 'house'] as const).map(st => <button key={st} onClick={() => updateData({
              sharedSpaceType: st
            })} className={`w-full flex items-center p-3 rounded-lg border transition-all ${data.sharedSpaceType === st ? 'border-lime-1 bg-lime-5 text-light-1' : 'border-dark-3 bg-dark-1 text-light-3 hover:text-light-2'}`} data-id="element-1586">
                      <div className={`w-4 h-4 rounded-full border flex items-center justify-center mr-3 ${data.sharedSpaceType === st ? 'border-lime-1' : 'border-dark-4'}`} data-id="element-1587">
                        {data.sharedSpaceType === st && <div className="w-2 h-2 rounded-full bg-lime-1" data-id="element-1588" />}
                      </div>
                      <span className="text-sm" data-id="element-1589">
                        {st === 'apartment' ? 'Într-un apartament comun' : 'Într-o casă / vilă'}
                      </span>
                    </button>)}
                </div>}
            </div>;
      })}
      </div>

      <div className="pt-6 border-t border-dark-3 space-y-6" data-id="element-1590">
        <div className="space-y-3" data-id="element-1591">
          <label className="block text-sm font-medium text-light-2" data-id="element-1592">
            {isHouse ? 'Etaje preferate' : 'Etajul'}
          </label>

          {isHouse ? <div className="flex flex-wrap gap-2" data-id="element-1593">
              {HOUSE_FLOORS.map(opt => {
            const isSelected = (data.floorPreferences || []).includes(opt.value as any);
            return <button key={opt.value} onClick={() => toggleFloor(opt.value)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors border ${isSelected ? 'bg-lime-1 border-lime-1 text-dark-1' : 'bg-dark-2 border-dark-4 text-light-2 hover:border-light-3'}`} data-id="element-1594">
                    {opt.label}
                  </button>;
          })}
            </div> : <>
              <div className="flex flex-wrap gap-2" data-id="element-1595">
                {APARTMENT_FIXED_PILLS.map(opt => {
              const isSelected = (data.floorPreferences || []).includes(opt.value as any);
              return <button key={opt.value} onClick={() => toggleFloor(opt.value)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors border ${isSelected ? 'bg-lime-1 border-lime-1 text-dark-1' : 'bg-dark-2 border-dark-4 text-light-2 hover:border-light-3'}`} data-id="element-1596">
                      {opt.label}
                    </button>;
            })}
              </div>

              <div className="pt-3" data-id="element-1597">
                <label className="block text-xs font-medium text-light-3 mb-1.5" data-id="element-1598">
                  Sau etaj exact / interval (opțional)
                </label>
                <Input value={data.floorExact || ''} onChange={e => updateData({
              floorExact: e.target.value
            })} placeholder="ex: 2 sau 1-3" className="bg-dark-2 border-dark-3 max-w-xs" data-id="element-1599" />
              </div>
            </>}
        </div>

        <div className="space-y-3" data-id="element-1600">
          <PeriodDropdown value={data.constructionYear || ''} onChange={v => updateData({
          constructionYear: v as any
        })} data-id="element-1601" />
        </div>
      </div>
    </div>;
}
function PeriodDropdown({
  value,
  onChange
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);
  const selected = CONSTRUCTION_PERIOD_OPTIONS.find(o => o.value === value);
  return <div className="relative max-w-xs" ref={ref} data-id="element-1602">
      <label className="block text-sm font-medium text-light-2 mb-2" data-id="element-1603">
        Anul Construcției
      </label>
      <button type="button" onClick={() => setIsOpen(v => !v)} aria-haspopup="listbox" aria-expanded={isOpen} className={cn('w-full h-11 px-4 rounded-md text-sm flex items-center justify-between transition-colors cursor-pointer', 'bg-dark-2 border', value ? 'border-lime-1 text-light-1' : 'border-dark-3 text-light-3 hover:border-dark-4')} data-id="element-1604">
        <span className="truncate pr-2 text-left" data-id="element-1605">
          {selected ? selected.label : 'Indiferent'}
        </span>
        <CaretDown size={14} weight="bold" className={cn('shrink-0 text-light-3 transition-transform', isOpen && 'rotate-180')} data-id="element-1606" />
      </button>

      {isOpen && <ul role="listbox" className="absolute top-full left-0 right-0 mt-2 z-50 max-h-72 overflow-y-auto rounded-xl bg-dark-2 border border-white/15 py-1 animate-in fade-in slide-in-from-top-2 dark-scrollbar" data-id="element-1607">
          {CONSTRUCTION_PERIOD_OPTIONS.map(opt => {
        const isSelected = value === opt.value;
        return <li key={opt.value} data-id="element-1608">
                <button type="button" onClick={() => {
            onChange(opt.value);
            setIsOpen(false);
          }} className={cn('w-full text-left px-4 py-2.5 text-sm transition-colors cursor-pointer flex items-center gap-3', isSelected ? 'bg-dark-3 text-light-1' : 'text-light-2 hover:bg-dark-3 hover:text-light-1')} data-id="element-1609">
                  <div className={cn('w-4 h-4 rounded-full border flex items-center justify-center shrink-0 transition-colors', isSelected ? 'border-lime-1' : 'border-light-3')} data-id="element-1610">
                    {isSelected && <div className="w-2 h-2 rounded-full bg-lime-1" data-id="element-1611" />}
                  </div>
                  {opt.label}
                </button>
              </li>;
      })}
        </ul>}
    </div>;
}